let inputTimeout = null;
export const debounce = (callback: (...args: any) => void, timeout_interval?: number): void => {
    if (inputTimeout) {
        clearTimeout(inputTimeout);
    }
    inputTimeout = setTimeout(() => {
        return callback();
    }, timeout_interval || 600);
};
